import startOfDay from 'date-fns/startOfDay';
import { DateTime } from 'luxon';
import { addDays, isBefore, isSameDay } from 'date-fns';

export function toStartOfDay(date: Date, timezone = 'UTC'): Date {
  return DateTime.fromJSDate(date).setZone(timezone).startOf('day').setZone(timezone).toJSDate();
}

export function toEndOfDay(date: Date, timezone = 'UTC'): Date {
  return DateTime.fromJSDate(date).setZone(timezone).endOf('day').toJSDate();
}

export function consecutiveDays(dateA: Date, dateB: Date, timezone = 'UTC'): boolean {
  if (!dateA || !dateB) {
    return false;
  }

  const midnightB = toStartOfDay(dateB, timezone);
  const timeBeforeMidnightB = midnightB.getTime() - dateA.getTime();

  return timeBeforeMidnightB > 0 && timeBeforeMidnightB <= 86400000;
}

export function sameDay(dateA: Date, dateB: Date, timezone = 'UTC'): boolean {
  if (!dateA || !dateB) {
    return false;
  }
  return toStartOfDay(dateA, timezone).getTime() === toStartOfDay(dateB, timezone).getTime();
}

export function isLeapYear(year: number): boolean {
  return year % 100 === 0 ? year % 400 === 0 : year % 4 === 0;
}

export function toMonthDay(date: Date | string): string {
  if (typeof date === 'string') {
    date = new Date(date);
  }
  return `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date
    .getDate()
    .toString()
    .padStart(2, '0')}`;
}

export function generateDateRange(startDateInclusive: Date, endDateInclusive: Date): Date[] {
  const dateArray: Date[] = [];

  let currentDate = startDateInclusive;

  while (isBefore(currentDate, endDateInclusive) || isSameDay(currentDate, endDateInclusive)) {
    dateArray.push(startOfDay(currentDate));
    currentDate = addDays(currentDate, 1);
  }

  return dateArray;
}
